import { useMemo } from 'react';
import useNumberArray from './array/useNumber';
export function useNumber(initial, options = {}) {
    const [value, actions] = useNumberArray(initial, options);
    return useMemo(() => (Object.assign({ value }, actions)), [actions, value]);
}
export default useNumber;
//# sourceMappingURL=useNumber.js.map